import { computed, effect, inject, Injectable, signal } from '@angular/core';

import { IZA_REQUEST_CNPJ_SELECTION } from '../iza-config';
import { CnpjStoreService } from '../services/cnpj-store.service';

export type IzaBubbleState = 'closed' | 'open' | 'expanded';

/**
 * Estado compartilhado do balão da Iza. O host (Otimiza) injeta este serviço
 * para abrir o balão a partir do próprio menu, em vez de navegar para fora.
 */
@Injectable({ providedIn: 'root' })
export class IzaBubbleService {
  private readonly cnpjStore = inject(CnpjStoreService);
  private readonly requestCnpjSelection = inject(IZA_REQUEST_CNPJ_SELECTION, { optional: true });

  readonly state = signal<IzaBubbleState>('closed');

  // Sem CNPJ o chat não consegue responder (o envio já é bloqueado em
  // ai-chat.service). Em vez de abrir um painel morto, pede o CNPJ ao host.
  // O guard vive aqui, e não no componente, para valer também quando o host
  // abre o balão pelo menu.
  readonly hasCnpj = computed(() => this.cnpjStore.selectedCnpj() !== null);
  readonly showCnpjWarning = signal(false);

  constructor() {
    effect(() => {
      if (this.hasCnpj()) this.showCnpjWarning.set(false);
    });
  }

  open(): void {
    if (!this.hasCnpj()) {
      this.showCnpjWarning.set(true);
      this.selectCnpj();
      return;
    }
    this.state.set('open');
  }

  close(): void {
    this.state.set('closed');
  }

  toggleExpand(): void {
    this.state.update(s => (s === 'expanded' ? 'open' : 'expanded'));
  }

  /** Abre o seletor de CNPJ do host, se ele tiver fornecido um. */
  selectCnpj(): void {
    this.requestCnpjSelection?.();
  }
}
